module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/web3-eth-ens/~/websocket/lib/version.js
// module id = 1889
// module chunks = 0 1 3